import React, { useState } from "react";
import PropTypes from "prop-types";
import { ImageSlider } from "@qgiv/core-react";
import { CardImage } from "@qgiv/core-donor";

const ProductImages = ({
    displayImageCarrousel = false,
    images,
    imgSrc,
    title,
}) => {
    const [activeImageKey, setActiveImageKey] = useState(0);

    return displayImageCarrousel ? (
        <ImageSlider
            activeImageKey={activeImageKey}
            onToggle={setActiveImageKey}
        >
            {images.map(({ id, filename, url }, index) => (
                <div key={id}>
                    <ImageSlider.Content
                        imageKey={index}
                        imageCount={images.length}
                    >
                        <CardImage url={url} altText={filename} />
                    </ImageSlider.Content>
                </div>
            ))}
            <div className="thumbnail-container">
                {images.map(({ id, filename, url }, index) => (
                    <div key={id}>
                        <ImageSlider.Thumbnails imageKey={index}>
                            <img
                                src={url}
                                alt={filename}
                                className="thumbnail__size--regular"
                            />
                        </ImageSlider.Thumbnails>
                    </div>
                ))}
            </div>
        </ImageSlider>
    ) : (
        <div className="store-details__img-container">
            <CardImage url={imgSrc} altText={title} display="square" />
        </div>
    );
};

ProductImages.propTypes = {
    displayImageCarrousel: PropTypes.bool,
    images: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    imgSrc: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
};

export default ProductImages;
